export enum OrderStatus {
    InProcess,
    Finished
}